let observer;

function startObserver() {
  const ci = document.getElementById("cart-items");
  const oct = document.querySelector(".wcp-original-cart-total");

  if (observer) {
    observer.disconnect();
  }

  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target === ci && mutation.type === "childList") {
        const inlineStyle = oct.style.textDecoration;
        if (computedStyle === "none" || inlineStyle === "none" || !inlineStyle) {
          oct.classList.add("show");
          observer.disconnect();
          return;
        }

        if (computedStyle !== "none" || (inlineStyle && inlineStyle !== "none")) {
          oct.classList.remove("show");
          observer.disconnect();
        }
      }

      if (mutation.target === oct && mutation.type === "attributes" && mutation.attributeName === "style") {
        const computedStyle = getComputedStyle(oct).textDecoration;
        const inlineStyle = oct.style.textDecoration;

        if (computedStyle === "none" || inlineStyle === "none") {
          observer.disconnect();
          oct.classList.add("show");
          return;
        }

        if (computedStyle !== "none" || (inlineStyle && inlineStyle !== "none")) {
          oct.classList.remove("show");
        }
      }
    });
  });

  observer.observe(ci, {
    childList: true,
    subtree: true,
  });

  observer.observe(oct, {
    attributes: true,
    attributeFilter: ["style"],
  });
}

function pricesStyle() {
  const cartItems = document.getElementById("cart-items");
  const originalCartTotal = document.querySelector(".wcp-original-cart-total");
  if (!cartItems || !originalCartTotal) {
    return;
  }
  startObserver();
}

document.addEventListener("DOMContentLoaded", () => {
  pricesStyle();
});

document.addEventListener("on:line-item:change", (e) => {
  setTimeout(() => {
    location.reload();
  }, 750);
});
